import request from './request';

export function signUpNewsletter(data) {
    return request('post', '/apiv2/newsletters/sign-up', data);
}